import { Broker, Partner, Bank, Notes, Feedback } from '.'

export const steps = [
  {
    id: 'broker',
    icon: 'briefcase',
    title: 'Informações da Corretora de Seguros',
    description:
      'Para iniciar o processo, insira abaixo os dados operacionais da sua corretora - usaremos as informações para deixá-lo informado sobre o status do cadastro (aprovação, ativação, pendências ou recusa).',
    render: Broker,
  },

  {
    id: 'partner',
    icon: 'link',
    title: 'Cadastro do Estipulante',
    description: 'Informe a seguir os dados do Estipulante/Imobiliária.',
    render: Partner,
  },

  {
    id: 'bank',
    icon: 'dollar-sign',
    title: 'Dados bancários',
    description: 'Informe os dados bancários da Estipulante.',
    render: Bank,
  },

  {
    id: 'notes',
    icon: 'list',
    title: 'Notas de esclarecimento',
    description:
      'Leia abaixo as notas sobre a ativação, assinatura e formalização do cadastro do estipulante. E ao fim da página conclua o cadastro clicando em "Concluir cadastro".',
    render: Notes,
  },

  {
    id: 'feedback',
    icon: 'check-square',
    title: 'Sua solicitação foi enviada com sucesso!',
    description:
      'Será enviado por email uma cópia do preenchimento e, em até 3 dias você receberá um retorno.<br />Conte com a gente!',
    render: Feedback,
  },
] as const

export type StepsKeys = typeof steps[number]['id']
